import React, { useState, useRef, useEffect } from "react";
import "../styles/transaction.css";
import addIcon from "../images/my_profile/add.svg"; // Add your add icon here
import manage_nominees from "../images/my_profile/manage_nominees.svg";
import pen_inner from "../images/my_profile/pen_inner.svg";

import arrow from "../images/my_profile/arrow.svg";
import plus from "../images/my_profile/plus.svg";
import calendar_month from "../images/my_profile/calendar_month.svg"; // Add your calendar icon path
import SelectDropDown from "./SelectDropDown"; // Assuming this is a custom component
import DatePickerInput from "./DatePickerInput";
import { useFormik } from "formik";
import "../styles/profile.css";
import * as Yup from "yup";
import view from "../images/my_profile/eye.svg";
import {
  userNomineeDetail,
  userNomineeDetailAdd,
  userOnboardingGetDetails,
} from "../actions/usersActions";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageUserData } from "../utils/userData";
import {
  convertDateToDDMMMYYYY,
  convertDateToDDMMMYYYYLetter,
} from "../utils/DateFormate";
import { toast } from "react-toastify";
import { pincode } from "../actions/usersActions";

const getOrdinalSuffix = (index) => {
  const j = index % 10,
    k = index % 100;

  if (j === 1 && k !== 11) return `${index}st`;
  if (j === 2 && k !== 12) return `${index}nd`;
  if (j === 3 && k !== 13) return `${index}rd`;
  return `${index}th`;
};

const ManageNominees = () => {
  const [currentView, setCurrentView] = useState("view");
  const [nomineeCount, setNomineeCount] = useState(1);
  const [noNominee, setNoNominee] = useState("N");
  const [soaNominee, setSoaNominee] = useState("N");
  const [save, setSave] = useState(false);
  const [editId, setEditId] = useState(0);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false); // Track if form is submitted
  const dispatch = useDispatch();
  const userData = getLocalStorageUserData();
  const { userNomineeDet, userOnboardGetData } = useSelector(
    (state) => state.users
  );
  const { userGetProfile } = useSelector((state) => state.users);

  // Handlers for view and add clicks
  const handleViewClick = () => setCurrentView("view");
  const handleAddClick = () => setCurrentView("add");
  const handleEditClick = () => setCurrentView("edit");

  const dateInputRef = useRef(null);
  // State to manage the nominees list
  const [nominees, setNominees] = useState([
    { name: "", relation: "", dob: "", percent: "", pan: "" },
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedNominees = [...nominees];
    updatedNominees[index][field] = value;
    setNominees(updatedNominees);
  };

  useEffect(() => {
    const payload = {
      id: userData?.id,
      completed_wizard_step: "3",
    };
    dispatch(userOnboardingGetDetails(payload));
  }, []);

  const parseDate = (input) => {
    if (!input) return null;

    // Check if input is ISO format
    if (input.includes("T")) {
      const date = new Date(input);
      return isNaN(date.getTime()) ? null : date;
    }

    // Assume format is DD-MM-YYYY
    const [day, month, year] = input.split("-").map(Number);
    if (!day || !month || !year) return null;

    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const calculateAge = (dob) => {
    const birthDate = parseDate(dob);
    if (!birthDate) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const addNominee = () => {
    if (nomineeCount != 3) {
      //   setNominees([
      //     ...nominees,
      //     { name: "", relation: "", dob: "", percent: "", pan: "" },
      //   ]);
      setNomineeCount(nomineeCount + 1);
      setNoNominee("N");
      const prefix =
        nomineeCount === 1
          ? `nominee_${nomineeCount + 1}`
          : `nominee_${nomineeCount + 1}`;
      // Special case for address keys
      const address1Key =
        nomineeCount === 1
          ? `nominee_${nomineeCount + 1}_address1`
          : `nominee_${nomineeCount + 1}_address1`;

      formik.setValues({
        ...values,
        [`nominee_${nomineeCount + 1}_name`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_name`
          ] || "",
        [`nominee_${nomineeCount + 1}_relationship`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_relationship`
          ] || "",
        [`nominee_${nomineeCount + 1}_dob`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_dob`
          ] != null
            ? userNomineeDet?.data?.user?.customers?.[
                `nominee_${nomineeCount + 1}_dob`
              ]
            : "" || "",
        [`nominee_${nomineeCount + 1}_applicable`]: userNomineeDet?.daser
          ?.customersser_profile?.[`nominee_${nomineeCount + 1}_applicable`]
          ? parseFloat(
              userNomineeDet?.data?.user?.customers?.[
                `nominee_${nomineeCount + 1}_applicable`
              ]
            ).toFixed(2)
          : "" || "",
        [`nominee_${nomineeCount + 1}_guardian`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_guardian`
          ] || "",
        [`nominee_${nomineeCount + 1}_guardian_pan`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_guardian_pan`
          ] || "",
        // [`nominee_${nomineeCount + 1}_guardian_relationship`]:
        //   userNomineeDet?.data?.user?.customers?.[
        //     `nominee_${nomineeCount + 1}_guardian_relationship`
        //   ] || "",
        [`nominee_${nomineeCount + 1}_identity_type`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_identity_type`
          ] || "1",
        [`nominee_${nomineeCount + 1}_identity_number`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_identity_number`
          ] || "",
        [`nominee_${nomineeCount + 1}_email`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_email`
          ] || "",
        [`nominee_${nomineeCount + 1}_mobile`]:
          userNomineeDet?.data?.user?.customers?.[
            `nominee_${nomineeCount + 1}_mobile`
          ] || "",
        [`${address1Key}`]:
          userNomineeDet?.data?.user?.customers?.[`${address1Key}`] || "",
        [`${prefix}_pin`]:
          userNomineeDet?.data?.user?.customers?.[`${prefix}_pin`] || "",
        [`${prefix}_city`]:
          userNomineeDet?.data?.user?.customers?.[`${prefix}_city`] || "",
        // [`${prefix}_state`]:
        //   userNomineeDet?.data?.user?.customers?.[`${prefix}_state`] || "",
      });
    }
  };

  const handleIconClick = () => {
    if (dateInputRef.current) {
      if (dateInputRef.current.showPicker) {
        dateInputRef.current.showPicker(); // For modern browsers
      } else {
        dateInputRef.current.focus(); // Fallback for older browsers
      }
    }
  };

  // const handleIconClick = (inputId) => {
  //   const input = document.getElementById(inputId);
  //   if (input) {
  //     input.focus();
  //   }
  // };

  console.log("userNomineeDetuserNomineeDet", userNomineeDet);
  useEffect(() => {
    if (userNomineeDet?.data?.user?.customers?.nominee_soa) {
      setSoaNominee(userNomineeDet?.data?.user?.customers?.nominee_soa);
      setNoNominee(
        userNomineeDet?.data?.user?.customers?.nomination_opt == true
          ? "Y"
          : "N"
      );
    }
  }, [userNomineeDet]);

  const formik = useFormik({
    initialValues: {
      noNominee:
        userNomineeDet?.data?.user?.customers?.nomination_opt == true
          ? "Y"
          : "N",
      nominee_1_name:
        userNomineeDet?.data?.user?.customers?.nominee_1_name || "",
      nominee_1_relationship:
        userNomineeDet?.data?.user?.customers?.nominee_1_relationship || "",
      nominee_1_dob:
        userNomineeDet?.data?.user?.customers?.nominee_1_dob != null
          ? userNomineeDet?.data?.user?.customers?.nominee_1_dob
          : "" || "",
      nominee_1_applicable: userNomineeDet?.data?.user?.customers
        ?.nominee_1_applicable
        ? parseFloat(
            userNomineeDet?.data?.user?.customers?.nominee_1_applicable
          ).toFixed(2) || ""
        : "",
      // nominee_1_pan: userNomineeDet?.data?.user?.customers?.nominee_1_pan || "",
      nominee_1_guardian:
        userNomineeDet?.data?.user?.customers?.nominee_1_guardian || "",
      nominee_1_guardian_pan:
        userNomineeDet?.data?.user?.customers?.nominee_1_guardian_pan || "",
      // New fields
      nominee_1_identity_type: "1",
      nominee_1_identity_number:
        userNomineeDet?.data?.user?.customers?.nominee_1_identity_number || "",
      nominee_1_email:
        userNomineeDet?.data?.user?.customers?.nominee_1_email || "",
      nominee_1_mobile:
        userNomineeDet?.data?.user?.customers?.nominee_1_mobile || "",
      nominee_1_address1:
        userNomineeDet?.data?.user?.customers?.nominee_1_address1
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_1_address2:
        userNomineeDet?.data?.user?.customers?.nominee_1_address2
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_1_city:
        userNomineeDet?.data?.user?.customers?.nominee_1_city || "",
      nominee_1_pin: userNomineeDet?.data?.user?.customers?.nominee_1_pin || "",
      // nominee_1_state:
      //   userNomineeDet?.data?.user?.customers?.nominee_1_state || "",
      nominee_1_country:
        userNomineeDet?.data?.user?.customers?.nominee_1_country || "",

      nominee_2_name:
        userNomineeDet?.data?.user?.customers?.nominee_2_name || "",
      nominee_2_relationship:
        userNomineeDet?.data?.user?.customers?.nominee_2_relationship || "",
      // ...(userNomineeDet?.data?.user?.customers?.nominee_2_pan
      //   ? { nominee_2_pan: userNomineeDet?.data?.user?.customers?.nominee_2_pan }
      //   : {}),
      nominee_2_dob:
        userNomineeDet?.data?.user?.customers?.nominee_2_dob != null
          ? userNomineeDet?.data?.user?.customers?.nominee_2_dob
          : "" || "",
      nominee_2_applicable: userNomineeDet?.data?.user?.customers
        ?.nominee_2_applicable
        ? parseFloat(
            userNomineeDet?.data?.user?.customers?.nominee_2_applicable
          ).toFixed(2)
        : 0 || "",
      nominee_2_guardian:
        userNomineeDet?.data?.user?.customers?.nominee_2_guardian || "",
      nominee_2_guardian_pan:
        userNomineeDet?.data?.user?.customers?.nominee_2_guardian_pan || "",
      //
      nominee_2_identity_type: "1",

      nominee_2_identity_number:
        userNomineeDet?.data?.user?.customers?.nominee_2_identity_number || "",
      nominee_2_email:
        userNomineeDet?.data?.user?.customers?.nominee_2_email || "",
      nominee_2_mobile:
        userNomineeDet?.data?.user?.customers?.nominee_2_mobile || "",
      nominee_2_address1:
        userNomineeDet?.data?.user?.customers?.nominee_2_address1
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_2_address2:
        userNomineeDet?.data?.user?.customers?.nominee_2_address2
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_2_city:
        userNomineeDet?.data?.user?.customers?.nominee_2_city || "",
      nominee_2_pin: userNomineeDet?.data?.user?.customers?.nominee_2_pin || "",
      // nominee_2_state:
      //   userNomineeDet?.data?.user?.customers?.nominee_2_state || "",
      nominee_2_country:
        userNomineeDet?.data?.user?.customers?.nominee_2_country || "",

      nominee_3_name:
        userNomineeDet?.data?.user?.customers?.nominee_3_name || "",
      nominee_3_relationship:
        userNomineeDet?.data?.user?.customers?.nominee_3_relationship || "",
      nominee_3_dob:
        userNomineeDet?.data?.user?.customers?.nominee_3_dob != null
          ? userNomineeDet?.data?.user?.customers?.nominee_3_dob
          : "" || "",
      // ...(userNomineeDet?.data?.user?.customers?.nominee_3_pan
      //   ? { nominee_3_pan: userNomineeDet?.data?.user?.customers?.nominee_3_pan }
      //   : {}),
      nominee_3_applicable: userNomineeDet?.data?.user?.customers
        ?.nominee_3_applicable
        ? parseFloat(
            userNomineeDet?.data?.user?.customers?.nominee_3_applicable
          ).toFixed(2)
        : 0 || "",
      nominee_3_guardian:
        userNomineeDet?.data?.user?.customers?.nominee_3_guardian || "",
      nominee_3_guardian_pan:
        userNomineeDet?.data?.user?.customers?.nominee_3_guardian_pan || "",
      // nominee_1_guardian_relationship:
      //   userNomineeDet?.data?.user?.customers?.nominee_1_guardian_relationship || "",
      // nominee_2_guardian_relationship:
      //   userNomineeDet?.data?.user?.customers?.nominee_2_guardian_relationship || "",
      // nominee_3_guardian_relationship:
      //   userNomineeDet?.data?.user?.customers?.nominee_3_guardian_relationship || "",
      // New Fields
      nominee_3_identity_type: "1",

      nominee_3_identity_number:
        userNomineeDet?.data?.user?.customers?.nominee_3_identity_number || "",
      nominee_3_email:
        userNomineeDet?.data?.user?.customers?.nominee_3_email || "",
      nominee_3_mobile:
        userNomineeDet?.data?.user?.customers?.nominee_3_mobile || "",
      nominee_3_address1:
        userNomineeDet?.data?.user?.customers?.nominee_3_address1
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_3_address2:
        userNomineeDet?.data?.user?.customers?.nominee_3_address2
          ?.replace(/\s+/g, " ")
          ?.trim() || "",
      nominee_3_city:
        userNomineeDet?.data?.user?.customers?.nominee_3_city || "",
      nominee_3_pin: userNomineeDet?.data?.user?.customers?.nominee_3_pin || "",
      // nominee_3_state:
      //   userNomineeDet?.data?.user?.customers?.nominee_3_state || "",
      nominee_3_country:
        userNomineeDet?.data?.user?.customers?.nominee_3_country || "IND",

      nominee_soa: userNomineeDet?.data?.user?.customers?.nominee_soa || "N",
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors = {};
      if (isFormSubmitted) {
        for (let i = 1; i <= nomineeCount; i++) {
          const nameKey = `nominee_${i}_name`;
          const relationKey = `nominee_${i}_relationship`;
          const dobKey = `nominee_${i}_dob`;
          const percentKey = `nominee_${i}_applicable`;
          const guardianNameKey = `nominee_${i}_guardian`;
          // const guardianRelationKey = `nominee_${i}_guardian_relationship`;
          const guardianPanKey = `nominee_${i}_guardian_pan`;
          const panKey = `nominee_${i}_pan`;

          // // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
          const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
          const pincodeKey = `${prefix}_pin`;
          const cityKey = `${prefix}_city`;
          // const stateKey = `${prefix}_state`;

          const idTypeKey = `nominee_${i}_identity_type`;
          const idNumberKey = `nominee_${i}_identity_number`;
          const emailKey = `nominee_${i}_email`;
          const mobileKey = `nominee_${i}_mobile`;
          // Special case for address keys
          const address1Key =
            i === 1 ? `nominee_${i}_address1` : `nominee_${i}_address1`;

          // const currentDate = new Date();
          const dob = values[dobKey];
          // console.log("dobdobdobdob", dob , currentDate , currentDate.getFullYear() dob.getFullYear())
          const age = calculateAge(dob);
          const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
          const mobileRegex = /^[6-9]\d{9}$/;

          if (!values[nameKey] || values[nameKey]?.trim() === "") {
            errors[nameKey] = "Name is required";
          } else if (
            !/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(values[nameKey]?.trim())
          ) {
            errors[nameKey] = "Name must contain only alphabets";
          }
          // if (age >= 18) {
          //   if (!values[panKey]) {
          //     errors[panKey] = "PAN Number is required";
          //   } else if (!panRegex.test(values[panKey])) {
          //     errors[panKey] = "Invalid PAN format (e.g., ABCDE1234F)";
          //   }
          // }
          if (!values[relationKey] || values[relationKey] === "Select")
            errors[relationKey] = "Relation is required";
          if (!values[dobKey]) errors[dobKey] = "Date of birth is required";
          if (
            !values[percentKey] ||
            values[percentKey] <= 0 ||
            values[percentKey] > 100
          ) {
            errors[percentKey] = "Percentage must be between 1 and 100";
          }

          console.log(":age", age);

          if (age < 18) {
            if (!values[guardianNameKey]) {
              errors[guardianNameKey] = "Guardian Name is required";
            } else if (!/^[A-Za-z\s]+$/.test(values[guardianNameKey])) {
              errors[guardianNameKey] =
                "Guardian Name must contain only alphabets";
            }

            // if (
            //   !values[guardianRelationKey] ||
            //   values[guardianRelationKey] === "Select"
            // )
            //   errors[guardianRelationKey] = "Guardian Relation is required";

            if (!values[guardianPanKey]) {
              errors[guardianPanKey] = "Guardian PAN is required";
            } else if (!panRegex.test(values[guardianPanKey])) {
              errors[guardianPanKey] = "Invalid PAN format (e.g., ABCDE1234F)";
            }
          }
          // Additional Field Validations
          // ID Type
          if (age > 18) {
            // if (!values[idTypeKey]) {
            //   errors[idTypeKey] = "Nominee ID Type is required";
            // }

            if (!values[idNumberKey]) {
              errors[idNumberKey] = "Nominee ID Number is required";
            } else {
              const idType = values[idTypeKey] || "1";
              const idNumber = values[idNumberKey];

              switch (idType) {
                case "1":
                  if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(idNumber)) {
                    errors[idNumberKey] =
                      "Invalid PAN format (e.g., ABCDE1234F)";
                  }
                  break;

                case "2":
                  if (!/^\d{4}$/.test(idNumber)) {
                    errors[idNumberKey] = "Enter last 4 digits of Aadhaar";
                  }
                  break;

                case "3": // Driving Licence
                  if (!/^[A-Z]{2}\d{2}\s?\d{11}$/.test(idNumber)) {
                    errors[idNumberKey] =
                      "Invalid Driving Licence format (e.g., MH12 12345678901)";
                  }
                  break;

                case "4": // Passport
                  if (!/^[A-PR-WY][0-9]{7}$/.test(idNumber)) {
                    errors[idNumberKey] =
                      "Invalid Passport format (e.g., A1234567)";
                  }
                  break;

                default:
                  errors[idNumberKey] = "Invalid ID Type selected";
                  break;
              }
            }
          }

          // Email (simple)
          if (!values[emailKey]) {
            errors[emailKey] = "Nominee Email is required";
          } else if (
            !values[emailKey].includes("@") ||
            !values[emailKey].includes(".")
          ) {
            errors[emailKey] = "Enter a valid email address";
          }
          console.log("values[mobileKey]", values[mobileKey]);

          // // Mobile (simple)
          if (!values[mobileKey]) {
            errors[mobileKey] = "Nominee Mobile Number is required";
          } else if (!mobileRegex.test(values[mobileKey])) {
            errors[mobileKey] = "Mobile number must be 10 digits";
          }

          // Address1
          if (!values[address1Key]) {
            errors[address1Key] = "Nominee Address is required";
          } else if (values[address1Key].length > 40) {
            errors[address1Key] = "Max 40 characters";
          }
          if (values[address2Key] && values[address2Key].length > 40) {
            errors[address2Key] = "Max 40 characters";
          }

          if (!values[pincodeKey]) {
            errors[pincodeKey] = "Nominee Pincode is required";
          } else if (
            String(values[pincodeKey]).length !== 6 ||
            isNaN(values[pincodeKey])
          ) {
            errors[pincodeKey] = "Pincode must be 6 digits";
          }

          // City
          if (!values[cityKey]) {
            errors[cityKey] = "Nominee City is required";
          }

          // State
          // if (!values[stateKey] || values[stateKey] === "Select") {
          //   errors[stateKey] = "Nominee State is required";
          // }
        }
      }
      console.log("errorserrorserrors", errors);
      return errors;
    },
    onSubmit: (values) => {
      setSave(true);
       if (values?.noNominee === "Y") {
    // Create payload with all nominee fields blank
    const payload = {
      noNominee: "Y",
      nominee_1_name: "",
      nominee_1_relationship: "",
      nominee_1_dob: "",
      nominee_1_applicable: "",
      nominee_1_guardian: "",
      nominee_1_guardian_pan: "",
      nominee_1_identity_type: "",
      nominee_1_identity_number: "",
      nominee_1_email: "",
      nominee_1_mobile: "",
      nominee_1_address1: "",
      nominee_1_address2: "",
      nominee_1_city: "",
      nominee_1_pin: "",
      nominee_1_country: "",
      nominee_2_name: "",
      nominee_2_relationship: "",
      nominee_2_dob: "",
      nominee_2_applicable: "",
      nominee_2_guardian: "",
      nominee_2_guardian_pan: "",
      nominee_2_identity_type: "",
      nominee_2_identity_number: "",
      nominee_2_email: "",
      nominee_2_mobile: "",
      nominee_2_address1: "",
      nominee_2_address2: "",
      nominee_2_city: "",
      nominee_2_pin: "",
      nominee_2_country: "",
      nominee_3_name: "",
      nominee_3_relationship: "",
      nominee_3_dob: "",
      nominee_3_applicable: "",
      nominee_3_guardian: "",
      nominee_3_guardian_pan: "",
      nominee_3_identity_type: "",
      nominee_3_identity_number: "",
      nominee_3_email: "",
      nominee_3_mobile: "",
      nominee_3_address1: "",
      nominee_3_address2: "",
      nominee_3_city: "",
      nominee_3_pin: "",
      nominee_3_country: "",
      completed_wizard_step: 3,
      no_of_nominees: 0,
    };

    dispatch(userNomineeDetailAdd(payload)).then((res) => {
      setCurrentView("view");
    });
  } else {
    const nom1 = values?.nominee_1_applicable ? parseFloat(values?.nominee_1_applicable) : 0;
    const nom2 = values?.nominee_2_applicable ? parseFloat(values?.nominee_2_applicable) : 0;
    const nom3 = values?.nominee_3_applicable ? parseFloat(values?.nominee_3_applicable) : 0;

    const payload = {
      ...values,
      nominee_1_dob: values?.nominee_1_dob ? convertDateToDDMMMYYYY(values.nominee_1_dob) : "",
      nominee_2_dob: values?.nominee_2_dob ? convertDateToDDMMMYYYY(values?.nominee_2_dob) : "",
      nominee_3_dob: values?.nominee_3_dob ? convertDateToDDMMMYYYY(values?.nominee_3_dob) : "",
      completed_wizard_step: 3,
      no_of_nominees: nomineeCount,
    };

    if (nom1 + nom2 + nom3 === 100) {
      dispatch(userNomineeDetailAdd(payload)).then((res) => {
        setCurrentView("view");
      });
    } else {
      toast.error("Total percentage cannot exceed 100%");
    }
  }
      // if(values?.noNominee == "Y"){
      //   formik.resetForm();
      //   formik.setFieldValue("noNominee", "Y")
      // }
      // const payload = {
      //   ...values,
      //   nominee_1_dob: values?.nominee_1_dob
      //     ? convertDateToDDMMMYYYY(values.nominee_1_dob)
      //     : "",
      //   nominee_2_dob: values?.nominee_2_dob
      //     ? convertDateToDDMMMYYYY(values?.nominee_2_dob)
      //     : "",
      //   nominee_3_dob: values?.nominee_3_dob
      //     ? convertDateToDDMMMYYYY(values?.nominee_3_dob)
      //     : "",
      //   completed_wizard_step: 3,
      //   no_of_nominees: nomineeCount,
      // };

      // const nom1 = values?.nominee_1_applicable
      //   ? parseFloat(values?.nominee_1_applicable)
      //   : 0;
      // const nom2 = values?.nominee_2_applicable
      //   ? parseFloat(values?.nominee_2_applicable)
      //   : 0;
      // const nom3 = values?.nominee_3_applicable
      //   ? parseFloat(values?.nominee_3_applicable)
      //   : 0;

      // if (payload.noNominee === "Y") {
      //   // ✅ Add noNominee flag in payload
      //   payload.noNominee = "Y";

      //   dispatch(userNomineeDetailAdd(payload)).then((res) => {
      //     setCurrentView("view");
      //   });
      // } else {
      //   if (nom1 + nom2 + nom3 === 100) {
      //     dispatch(userNomineeDetailAdd(payload)).then((res) => {
      //       setCurrentView("view");
      //     });
      //   } else {
      //     toast.error("Total percentage cannot exceed 100%");
      //   }
      // }
    },
  });

  useEffect(() => {
    setNomineeCount(
      userNomineeDet?.data?.user?.customers?.no_of_nominees == null
        ? 1
        : userNomineeDet?.data?.user?.customers?.no_of_nominees
    );
  }, [userNomineeDet]);
  useEffect(() => {
    dispatch(userNomineeDetail());
  }, []);

  const relationShip = (value) => {
    const option = userNomineeDet?.data?.relations?.find(
      (option) => option.relationship_code == value
    );
    return option ? option.relationship_name : null; // Return label or null if not found
  };

  const deleteNominee = (position) => {
    const updatedValues = { ...formik.values };

    for (let i = position; i < nomineeCount; i++) {
      const from = i + 1;
      const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
      const fromPrefix = from === 1 ? `nominee_${from}` : `nominee_${from}`;

      const address1Key =
        i === 1 ? `nominee_${i}_address1` : `nominee_${i}_address1`;
      const fromAddress1Key =
        from === 1 ? `nominee_${from}_address1` : `nominee_${from}_address1`;

      const address2Key =
        i === 1 ? `nominee_${i}_address2` : `nominee_${i}_address2`;
      const fromAddress2Key =
        from === 1 ? `nominee_${from}_address2` : `nominee_${from}_address2`;

      // Shift values up from next nominee
      updatedValues[`nominee_${i}_name`] =
        updatedValues[`nominee_${from}_name`] || "";
      updatedValues[`nominee_${i}_relationship`] =
        updatedValues[`nominee_${from}_relationship`] || "";
      updatedValues[`nominee_${i}_dob`] =
        updatedValues[`nominee_${from}_dob`] || "";
      // updatedValues[`nominee_${i}_pan`] = updatedValues[`nominee_${from}_pan`] || "";
      updatedValues[`nominee_${i}_applicable`] =
        updatedValues[`nominee_${from}_applicable`] || "";
      updatedValues[`nominee_${i}_guardian`] =
        updatedValues[`nominee_${from}_guardian`] || "";
      updatedValues[`nominee_${i}_guardian_pan`] =
        updatedValues[`nominee_${from}_guardian_pan`] || "";
      // updatedValues[`nominee_${i}_guardian_relationship`] =
      //   updatedValues[`nominee_${from}_guardian_relationship`] || "";

      updatedValues[`nominee_${i}_identity_type`] =
        updatedValues[`nominee_${from}_identity_type`] || "";
      updatedValues[`nominee_${i}_identity_number`] =
        updatedValues[`nominee_${from}_identity_number`] || "";
      updatedValues[`nominee_${i}_email`] =
        updatedValues[`nominee_${from}_email`] || "";
      updatedValues[`nominee_${i}_mobile`] =
        updatedValues[`nominee_${from}_mobile`] || "";

      updatedValues[`${prefix}_pin`] = updatedValues[`${fromPrefix}_pin`] || "";
      updatedValues[`${prefix}_city`] =
        updatedValues[`${fromPrefix}_city`] || "";
      // updatedValues[`${prefix}_state`] =
      //   updatedValues[`${fromPrefix}_state`] || "";
      updatedValues[`${prefix}_country`] =
        updatedValues[`${fromPrefix}_country`] || "";
      updatedValues[address1Key] = updatedValues[fromAddress1Key] || "";
      updatedValues[address2Key] = updatedValues[fromAddress2Key] || "";
    }

    // Clean up last nominee data
    const last = nomineeCount;
    const lastPrefix = last === 1 ? `nominee_${last}` : `nominee_${last}`;
    updatedValues[`nominee_${last}_name`] = "";
    updatedValues[`nominee_${last}_relationship`] = "";
    updatedValues[`nominee_${last}_dob`] = "";
    // updatedValues[`nominee_${last}_pan`] = "";
    updatedValues[`nominee_${last}_applicable`] = "";
    updatedValues[`nominee_${last}_guardian`] = "";
    updatedValues[`nominee_${last}_guardian_pan`] = "";
    // updatedValues[`nominee_${last}_guardian_relationship`] = "";
    updatedValues[`nominee_${last}_identity_type`] = "";
    updatedValues[`nominee_${last}_identity_number`] = "";
    updatedValues[`nominee_${last}_email`] = "";
    updatedValues[`nominee_${last}_mobile`] = "";
    updatedValues[`${lastPrefix}_pin`] = "";
    updatedValues[`${lastPrefix}_city`] = "";
    // updatedValues[`${lastPrefix}_state`] = "";
    updatedValues[`${lastPrefix}_country`] = "";
    updatedValues[
      last === 1 ? `nominee_${last}_address1` : `nominee_${last}_address1`
    ] = "";
    updatedValues[
      last === 1 ? `nominee_${last}_address2` : `nominee_${last}_address2`
    ] = "";
    setNomineeCount(nomineeCount - 1);
    formik.setValues(updatedValues);
  };
  const { values, errors, handleChange, setFieldValue, handleSubmit } = formik;
  const dob = new Date(values[`nominee_${editId}_dob`]);
  const nomineeTypeOptions = [
    { value: "1", label: "PAN" },
    { value: "2", label: "Aadhar" },
    { value: "3", label: "Driving Licence" },
    { value: "4", label: "Passport" },
  ];
  const callStateAndDistrict = async (pin, cityKey, countryKey) => {
    try {
      if (pin?.length === 6) {
        const payload = { pincode: pin };
        dispatch(pincode(payload))
          .then((res) => {
            formik?.setFieldValue(
              cityKey,
              res?.data?.data?.city ? res?.data?.data?.city : ""
            );
            // formik?.setFieldValue(stateKey, res?.data?.data?.state_code || "");
            // formik?.setFieldValue(
            //   countryKey,
            //   res?.data?.data?.country_code || ""
            // );
          })
          .catch((error) => {
            console.log("Error fetching city/state:", error);
          });
      }
    } catch (error) {
      console.error("Error in pincode lookup:", error);
    }
  };

  // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
  const prefix = editId === 1 ? `nominee_${editId}` : `nominee_${editId}`;
  const pincodeKey = `${prefix}_pin`;
  const cityKey = `${prefix}_city`;
  // const stateKey = `${prefix}_state`;

  const idTypeKey = `nominee_${editId}_identity_type`;
  const idNumberKey = `nominee_${editId}_identity_number`;
  const emailKey = `nominee_${editId}_email`;
  const mobileKey = `nominee_${editId}_mobile`;
  const countryKey = `nominee_${editId}_country`;

  // Special case for address keys
  const address1Key =
    editId === 1 ? `nominee_${editId}_address1` : `nominee_${editId}_address1`;
  const address2Key =
    editId === 1 ? `nominee_${editId}_address2` : `nominee_${editId}_address2`;

  return (
    <div className="accordion-item">
      <h2 className="accordion-header profile_header" id="headingEight">
        <button
          className="accordion-button collapsed px-lg-4 px-md-4 px-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseEight"
          aria-expanded="false"
          aria-controls="collapseEight"
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img
                src={manage_nominees}
                alt=""
                className="personel_details_img"
              />
              {/* <span className="personal_inner_text">Manage Nominees</span> */}
              <span className="personal_inner_text">
                {currentView === "view" && "Manage Nominees"}
                {currentView === "add" && "Manage Nominees Add"}
                {currentView === "edit" && "Manage Nominees Edit"}
              </span>
            </div>

            {/* <div className="edit_personel">
                            <span className="badge editBadge">
                                <img src={addIcon} alt="" className="pen_image" />
                                <span className="editInner d-sm-block d-none">Add</span>
                            </span>
                        </div> */}
          </div>
        </button>
      </h2>
      <div
        id="collapseEight"
        className="accordion-collapse collapse"
        aria-labelledby="headingEight"
        data-bs-parent="#accordionExample"
      >
        <hr className="m-0" />

        <div className="accordion-body profile_accordion_body redeam_bottom_card">
          <div className="d-flex justify-content-end align-items-right">
            <div className="edit_personel">
              {currentView !== "view" && (
                <>
                  <span
                    onClick={handleViewClick}
                    className="badge editBadge profile-mr"
                  >
                    <img src={view} alt="View Icon" className="pen_image" />

                    <span className="editInner d-sm-block d-none">View</span>
                  </span>
                </>
              )}

              {currentView === "view" && (
                <span
                  onClick={handleAddClick}
                  className="badge editBadge addbank-btn-mb profile-mr"
                >
                  <img src={addIcon} alt="" className="pen_image" />

                  <span
                    className="editInner d-sm-block d-none"
                    onClick={handleAddClick}
                  >
                    Add
                  </span>
                </span>
              )}

              {/* </span> */}
            </div>
          </div>

          {/* Manage Noaminess Details Table */}

          {currentView === "view" && (
            <div className="table-responsive bankDetailTable">
              <table className="table ">
                <thead>
                  <tr>
                    <th scope="col">Sr. No.</th>
                    <th scope="col">Name</th>
                    <th scope="col">Relation</th>
                    <th scope="col">DOB</th>
                    <th scope="col">%</th>
                    {/* <th scope="col">Pan</th> */}
                    <th scope="col">Email</th>
                    <th scope="col">Mobile</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(userNomineeDet?.data?.user?.customers?.nominee_1_name?.trim() ==
                    "" ||
                    userNomineeDet?.data?.user?.customers?.nominee_1_name ==
                      null ||
                    userNomineeDet?.data?.user?.customers?.nominee_1_name ==
                      "null") &&
                    (userNomineeDet?.data?.user?.customers?.nominee_2_name?.trim() ==
                      "" ||
                      userNomineeDet?.data?.user?.customers?.nominee_2_name ==
                        null ||
                      userNomineeDet?.data?.user?.customers?.nominee_2_name ==
                        "null") &&
                    (userNomineeDet?.data?.user?.customers?.nominee_3_name?.trim() ==
                      "" ||
                      userNomineeDet?.data?.user?.customers?.nominee_3_name ==
                        null ||
                      userNomineeDet?.data?.user?.customers?.nominee_3_name ==
                        "null") && <tr>No nominee found</tr>}
                  {userNomineeDet?.data?.user?.customers?.nominee_1_name?.trim() !=
                    "" &&
                    userNomineeDet?.data?.user?.customers?.nominee_1_name !=
                      null &&
                    userNomineeDet?.data?.user?.customers?.nominee_1_name !=
                      "null" && (
                      <tr>
                        <td>1</td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_1_name
                          }
                        </td>
                        <td>
                          {relationShip(
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_1_relationship
                          )}
                        </td>
                        <td>
                          {/* {convertDateToDDMMYYYY( */}
                          {convertDateToDDMMMYYYYLetter(
                            userNomineeDet?.data?.user?.customers?.nominee_1_dob
                          )}
                          {/* )} */}
                        </td>
                        <td>
                          {userNomineeDet?.data?.user?.customers
                            ?.nominee_1_applicable
                            ? Math.round(
                                userNomineeDet?.data?.user?.customers
                                  ?.nominee_1_applicable
                              )
                            : "NA"}
                          {/* {parseFloat(
                          userNomineeDet?.data?.user?.customers?.nominee_1_applicable
                        ).toFixed(2)} */}
                        </td>
                        {/* <td>{userNomineeDet?.data?.user?.customers?.nom1_pan}</td> */}
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_1_email
                          }
                        </td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_1_mobile
                          }
                        </td>
                        <td>
                          <button
                            className="details_edit_btn btn p-0"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="Edit"
                            onClick={() => {
                              handleEditClick();
                              setEditId(1);
                            }}
                          >
                            <img
                              src={pen_inner}
                              alt="Edit Nominee"
                              className="pen_image_inner"
                            />
                          </button>
                        </td>
                      </tr>
                    )}
                  {userNomineeDet?.data?.user?.customers?.nominee_2_name?.trim() !=
                    "" &&
                    userNomineeDet?.data?.user?.customers?.nominee_2_name !=
                      null &&
                    userNomineeDet?.data?.user?.customers?.nominee_2_name !=
                      "null" && (
                      <tr>
                        <td>2</td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_2_name
                          }
                        </td>
                        <td>
                          {relationShip(
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_2_relationship
                          )}
                        </td>
                        <td>
                          {/* {convertDateToDDMMYYYY( */}
                          {convertDateToDDMMMYYYYLetter(
                            userNomineeDet?.data?.user?.customers?.nominee_2_dob
                          )}
                          {/* )} */}
                        </td>
                        <td>
                          {userNomineeDet?.data?.user?.customers
                            ?.nominee_2_applicable
                            ? Math.round(
                                userNomineeDet?.data?.user?.customers
                                  ?.nominee_2_applicable
                              )
                            : "NA"}
                          {/* {parseFloat(
                          userNomineeDet?.data?.user?.customers?.nominee_2_applicable
                        ).toFixed(2)} */}
                        </td>
                        {/* <td>{userNomineeDet?.data?.user?.customers?.nom2_pan}</td> */}
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_2_email
                          }
                        </td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_2_mobile
                          }
                        </td>
                        <td>
                          <button
                            className="details_edit_btn btn p-0"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="Edit"
                            onClick={() => {
                              handleEditClick();
                              setEditId(2);
                            }}
                          >
                            <img
                              src={pen_inner}
                              alt="Edit Nominee"
                              className="pen_image_inner"
                            />
                          </button>
                        </td>
                      </tr>
                    )}
                  {userNomineeDet?.data?.user?.customers?.nominee_3_name?.trim() !=
                    "" &&
                    userNomineeDet?.data?.user?.customers?.nominee_3_name !=
                      null &&
                    userNomineeDet?.data?.user?.customers?.nominee_3_name !=
                      "null" && (
                      <tr>
                        <td>3</td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_3_name
                          }
                        </td>
                        <td>
                          {relationShip(
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_3_relationship
                          )}
                        </td>
                        <td>
                          {/* {convertDateToDDMMYYYY( */}
                          {convertDateToDDMMMYYYYLetter(
                            userNomineeDet?.data?.user?.customers?.nominee_3_dob
                          )}
                          {/* )} */}
                        </td>
                        <td>
                          {userNomineeDet?.data?.user?.customers
                            ?.nominee_3_applicable
                            ? Math.round(
                                userNomineeDet?.data?.user?.customers
                                  ?.nominee_3_applicable
                              )
                            : "NA"}
                          {/* {parseFloat(
                          userNomineeDet?.data?.user?.customers?.nominee_3_applicable
                        ).toFixed(2)} */}
                        </td>
                        {/* <td>{userNomineeDet?.data?.user?.customers?.nom3_pan}</td> */}
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_3_email
                          }
                        </td>
                        <td>
                          {
                            userNomineeDet?.data?.user?.customers
                              ?.nominee_3_mobile
                          }
                        </td>
                        <td>
                          <button
                            className="details_edit_btn btn p-0"
                            onClick={() => {
                              handleEditClick();
                              setEditId(3);
                            }}
                          >
                            <img
                              src={pen_inner}
                              alt="Edit Nominee"
                              className="pen_image_inner"
                            />
                          </button>
                        </td>
                      </tr>
                    )}

                  {/* Add more rows as needed */}
                </tbody>
              </table>
              {userNomineeDet?.data?.user?.customers?.nominee_1_name == "" &&
                userNomineeDet?.data?.user?.customers?.nominee_2_name == "" &&
                userNomineeDet?.data?.user?.customers?.nominee_3_name == "" && (
                  <p className="text-center">No nominees found</p>
                )}
            </div>
          )}

          {/* Add Noaminess Form */}

          {currentView === "add" && (
            <div>
              {/* Heading with Back Button */}
              {/* <div className="d-flex align-items-center mb-md-4 mb-3">
                <img src={arrow} alt="" className="add_bank_detail me-3" />
                <h5 className="m-0 add_bank_detail_text">Add Nominee</h5>
              </div> */}

              {/* Nominee Form */}
              <div className="row form_body justify-content-center">
                <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                  <p className="noteNominee mb-4">
                    <span className="noteHeading">Note </span>: You can add a
                    maximum of 3 Nominees.
                  </p>
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="no_nominee"
                      checked={noNominee == "Y"}
                      onChange={(e) => {
                        if (e.target.checked == true) {
                          setNomineeCount(0);
                          setNoNominee("Y");
                          formik.setFieldValue("noNominee", "Y");
                        } else {
                          setNomineeCount(1);
                          setNoNominee("N");
                          formik.setFieldValue("noNominee", "N");
                        }
                      }}
                    />
                    <label className="form-check-label" for="no_nominee">
                      Customer does not wish to add nominee.
                    </label>
                  </div>
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="nominee_soa"
                      checked={soaNominee == "Y"}
                      onChange={(e) => {
                        setSoaNominee(e.target.checked ? "Y" : "N");
                        formik.setFieldValue(
                          "nominee_soa",
                          e.target.checked ? "Y" : "N"
                        );
                      }}
                    />
                    <label className="form-check-label" for="no_nominee">
                      SOA
                    </label>
                    <div className="tooltip-wrapper">
                      <span className="fa fa-info-circle info-icon"></span>
                      <div className="tooltip-content">
                        If the SOA is checked, only the nominee registration
                        status will be shown in the SOA.
                        <br />
                        If unchecked, the names of the registered nominee will
                        be displayed.
                      </div>
                    </div>
                  </div>

                  <form onSubmit={formik.handleSubmit} id="manage_nominee">
                    {[...Array(nomineeCount)].map((_, index) => {
                      const i = index + 1;
                      const nameKey = `nominee_${i}_name`;
                      const relationKey = `nominee_${i}_relationship`;
                      const dobKey = `nominee_${i}_dob`;
                      const percentKey = `nominee_${i}_applicable`;
                      const panKey = `nominee_${i}_pan`;
                      const guardianNameKey = `nominee_${i}_guardian`;
                      const guardianPanKey = `nominee_${i}_guardian_pan`;

                      // const guardianRelationKey = `nominee_${i}_guardian_relationship`;

                      // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
                      const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
                      const pincodeKey = `${prefix}_pin`;
                      const cityKey = `${prefix}_city`;
                      const stateKey = `${prefix}_state`;

                      const idTypeKey = `nominee_${i}_identity_type`;
                      const idNumberKey = `nominee_${i}_identity_number`;
                      const emailKey = `nominee_${i}_email`;
                      const mobileKey = `nominee_${i}_mobile`;
                      const countryKey = `nominee_${i}_country`;

                      // Special case for address keys
                      const address1Key =
                        i === 1
                          ? `nominee_${i}_address1`
                          : `nominee_${i}_address1`;
                      const address2Key =
                        i === 1
                          ? `nominee_${i}_address2`
                          : `nominee_${i}_address2`;

                      // const dob = new Date(values[dobKey]);
                      const age = calculateAge(values[dobKey]);
                      return (
                        <div key={i}>
                          <div className="mb-4">
                            <h5 className="nominee_title">
                              {`${getOrdinalSuffix(i)} Nominee:`}
                            </h5>
                          </div>
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={nameKey} className="form-label">
                                Nominee Name*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={nameKey}
                                name={nameKey}
                                placeholder="Enter Nominee Name"
                                value={values[nameKey]}
                                onChange={handleChange}
                              />
                              {errors[nameKey] && (
                                <div className="text-danger">
                                  {errors[nameKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={relationKey}
                                className="form-label"
                              >
                                Relation*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={relationKey}
                                id={relationKey}
                                value={values[relationKey]}
                                changeFunction={(value) =>
                                  setFieldValue(relationKey, value)
                                }
                                options={userNomineeDet?.data?.relations?.map(
                                  (relation) => ({
                                    value: relation.relationship_code,
                                    label: relation.relationship_name,
                                  })
                                )}
                              />
                              {errors[relationKey] && (
                                <div className="text-danger">
                                  {errors[relationKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`dob-${index}`}
                                className="form-label"
                              >
                                Nominee Date of Birth*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <DatePickerInput
                                id={dobKey}
                                selectedDate={values[dobKey]}
                                maxDate={new Date().toISOString().split("T")[0]}
                                onChange={(date) => setFieldValue(dobKey, date)}
                                name={dobKey}
                              />
                              {errors[dobKey] && (
                                <div className="text-danger">
                                  {errors[dobKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`percent-${index}`}
                                className="form-label"
                              >
                                Nominee %*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="number"
                                id={percentKey}
                                name={percentKey}
                                className="form-control"
                                placeholder="Enter Nominee %"
                                value={values[percentKey]}
                                onChange={handleChange}
                              />
                              {errors[percentKey] && (
                                <div className="text-danger">
                                  {errors[percentKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {(age >= 18 || age === null) && (
                            <>
                              {/* Nominee Type */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idTypeKey}
                                    className="form-label"
                                  >
                                    Nominee Identity Type *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={idTypeKey}
                                    id={idTypeKey}
                                    value={values[idTypeKey] || "1"}
                                    changeFunction={(value) =>
                                      setFieldValue(idTypeKey, value)
                                    }
                                    options={nomineeTypeOptions?.map(
                                      (state) => ({
                                        value: state.value,
                                        label: state.label,
                                      })
                                    )}
                                    disabled="true"
                                  />
                                  {errors[idTypeKey] && (
                                    <div className="text-danger">
                                      {errors[idTypeKey]}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Nominee Id Number */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idNumberKey}
                                    className="form-label"
                                  >
                                    Nominee ID number *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={idNumberKey}
                                    name={idNumberKey}
                                    placeholder="Enter Id Number"
                                    value={values[idNumberKey] || ""}
                                    onChange={(e) => {
                                      const upperValue =
                                        e.target.value.toUpperCase();
                                      handleChange({
                                        target: {
                                          name: idNumberKey,
                                          value: upperValue,
                                        },
                                      });
                                    }}
                                  />
                                  {errors[idNumberKey] && (
                                    <div className="text-danger">
                                      {errors[idNumberKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Nominee Email */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={emailKey} className="form-label">
                                Nominee Email *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="email"
                                className="form-control"
                                id={emailKey}
                                name={emailKey}
                                placeholder="Enter Nominee Email"
                                value={values[emailKey] || ""}
                                // onChange={handleChange}
                                onChange={(e) =>
                                  setFieldValue(
                                    emailKey,
                                    e.target.value.toLowerCase()
                                  )
                                }
                              />
                              {errors[emailKey] && (
                                <div className="text-danger">
                                  {errors[emailKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Mobile Number */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={mobileKey} className="form-label">
                                Nominee Mobile *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="string"
                                className="form-control"
                                id={mobileKey}
                                name={mobileKey}
                                placeholder="Enter Nominee Mobile"
                                value={values[mobileKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[mobileKey] && (
                                <div className="text-danger">
                                  {errors[mobileKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address1Key}
                                className="form-label"
                              >
                                Nominee Address 1 *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address1Key}
                                name={address1Key}
                                placeholder="Enter Nominee Address 1"
                                value={values[address1Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address1Key] && (
                                <div className="text-danger">
                                  {errors[address1Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address 2 */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address2Key}
                                className="form-label"
                              >
                                Nominee Address 2
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address2Key}
                                name={address2Key}
                                placeholder="Enter Nominee Address 2"
                                value={values[address2Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address2Key] && (
                                <div className="text-danger">
                                  {errors[address2Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Pin Code */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={pincodeKey}
                                className="form-label"
                              >
                                Nominee Pincode *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                // type="number"
                                className="form-control"
                                id={pincodeKey}
                                name={pincodeKey}
                                placeholder="Enter Nominee Pincode"
                                value={values[pincodeKey] || ""}
                                onChange={(e) => {
                                  handleChange(e);
                                  callStateAndDistrict(
                                    e.target.value,
                                    cityKey,
                                    countryKey
                                  );
                                }}
                              />
                              {errors[pincodeKey] && (
                                <div className="text-danger">
                                  {errors[pincodeKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee City */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={cityKey} className="form-label">
                                Nominee City *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={cityKey}
                                name={cityKey}
                                placeholder="Enter Nominee City"
                                value={values[cityKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[cityKey] && (
                                <div className="text-danger">
                                  {errors[cityKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee State */}
                          {/* <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={stateKey} className="form-label">
                                Nominee State *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={stateKey}
                                id={stateKey}
                                value={values[stateKey] || ""}
                                changeFunction={(value) =>
                                  setFieldValue(stateKey, value)
                                }
                                options={userNomineeDet?.data?.states?.map(
                                  (state) => ({
                                    value: state.state_code,
                                    label: state.state_name,
                                  })
                                )}
                              />
                              {errors[stateKey] && (
                                <div className="text-danger">
                                  {errors[stateKey]}
                                </div>
                              )}
                            </div>
                          </div> */}

                          {/* Nominee Country */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={countryKey}
                                className="form-label"
                              >
                                Nominee Country *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                id={countryKey}
                                name={countryKey}
                                value={formik.values[countryKey] || ""}
                                changeFunction={(value) =>
                                  formik.setFieldValue(countryKey, value)
                                }
                                options={userNomineeDet?.data?.countries?.map(
                                  (state) => ({
                                    value: state.country_name,
                                    label: state.country_name,
                                  })
                                )}
                              />

                              {errors[countryKey] && (
                                <div className="text-danger">
                                  {errors[countryKey]}
                                </div>
                              )}
                            </div>
                          </div>
                          {age >= 18 || age === null ? (
                            <></>
                          ) : (
                            // <div className="row align-items-center mb-4">
                            //   <div className="col-lg-5 col-md-6">
                            //     <label htmlFor={panKey} className="form-label">
                            //       Enter Pan Number*
                            //     </label>
                            //   </div>
                            //   <div className="col-lg-7 col-md-6">
                            //     <input
                            //       type="text"
                            //       className="form-control"
                            //       id={panKey}
                            //       name={panKey}
                            //       placeholder="Enter Pan Number"
                            //       value={values[panKey]}
                            //       onChange={handleChange}
                            //     />
                            //     {errors[panKey] && (
                            //       <div className="text-danger">
                            //         {errors[panKey]}
                            //       </div>
                            //     )}
                            //   </div>
                            // </div>
                            <>
                              {" "}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Name*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianNameKey}
                                    name={guardianNameKey}
                                    className="form-control"
                                    placeholder="Guardian Name"
                                    value={values[guardianNameKey]}
                                    onChange={handleChange}
                                  />
                                  {errors[guardianNameKey] && (
                                    <div className="text-danger">
                                      {errors[guardianNameKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Pan*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianPanKey}
                                    name={guardianPanKey}
                                    className="form-control"
                                    placeholder="Guardian Pan"
                                    value={values[guardianPanKey]}
                                    onChange={(e) => {
                                      const upperValue =
                                        e.target.value.toUpperCase();
                                      handleChange({
                                        target: {
                                          name: guardianPanKey,
                                          value: upperValue,
                                        },
                                      });
                                    }}
                                  />
                                  {errors[guardianPanKey] && (
                                    <div className="text-danger">
                                      {errors[guardianPanKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={guardianRelationKey}
                                    className="form-label"
                                  >
                                    Guardian Relation*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={guardianRelationKey}
                                    id={guardianRelationKey}
                                    value={values[guardianRelationKey]}
                                    changeFunction={(value) =>
                                      setFieldValue(guardianRelationKey, value)
                                    }
                                    options={userOnboardGetData?.data?.relations?.map(
                                      (relation) => ({
                                        value: relation.value,
                                        label: relation.label,
                                      })
                                    )}
                                  />
                                  {errors[guardianRelationKey] && (
                                    <div className="text-danger">
                                      {errors[guardianRelationKey]}
                                    </div>
                                  )}
                                </div>
                              </div> */}
                            </>
                          )}
                          <button
                            type="button"
                            className="delete_button text-decoration-none"
                            onClick={deleteNominee}
                          >
                            <span>-</span> Delete nominee
                          </button>
                        </div>
                      );
                    })}

                    {nomineeCount < 3 && (
                      <button
                        type="button"
                        className="more_button text-decoration-none"
                        onClick={addNominee}
                      >
                        <span>+</span> Add More
                      </button>
                    )}

                    <div className="d-flex justify-content-center gap-2 mt-lg-5 mt-4">
                      <button
                        type="submit"
                        className="form_button next_btn"
                        onClick={() => setIsFormSubmitted(true)}
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* Edit Noaminess Form */}

          {currentView === "edit" && (
            <div>
              {/* Heading with Back Button */}
              {/* <div className="d-flex align-items-center mb-md-4 mb-3">
                <img src={arrow} alt="" className="add_bank_detail me-3" />
                <h5 className="m-0 add_bank_detail_text">Edit Nominee</h5>
              </div> */}

              {/* Nominee Form */}
              <div className="row form_body justify-content-center">
                <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="no_nominee"
                      checked={noNominee == "Y"}
                      onChange={(e) => {
                        if (e.target.checked == true) {
                          setNomineeCount(0);
                          setNoNominee("Y");
                          formik.setFieldValue("noNominee", "Y");
                        } else {
                          setNomineeCount(1);
                          setNoNominee("N");
                          formik.setFieldValue("noNominee", "N");
                        }
                      }}
                    />
                    <label className="form-check-label" for="no_nominee">
                      Customer does not wish to add nominee.
                    </label>
                  </div>
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="nominee_soa"
                      checked={soaNominee == "Y"}
                      onChange={(e) => {
                        setSoaNominee(e.target.checked ? "Y" : "N");
                        formik.setFieldValue(
                          "nominee_soa",
                          e.target.checked ? "Y" : "N"
                        );
                      }}
                    />
                    <label className="form-check-label" for="no_nominee">
                      SOA
                    </label>
                    <div className="tooltip-wrapper">
                      <span className="fa fa-info-circle info-icon"></span>
                      <div className="tooltip-content">
                        If the SOA is checked, only the nominee registration
                        status will be shown in the SOA.
                        <br />
                        If unchecked, the names of the registered nominee will
                        be displayed.
                      </div>
                    </div>
                  </div>
                  <form onSubmit={formik.handleSubmit} id="manage_nominee">
                    {[...Array(nomineeCount)].map((_, index) => {
                      const i = index + 1;
                      const nameKey = `nominee_${i}_name`;
                      const relationKey = `nominee_${i}_relationship`;
                      const dobKey = `nominee_${i}_dob`;
                      const percentKey = `nominee_${i}_applicable`;
                      const panKey = `nominee_${i}_pan`;
                      const guardianNameKey = `nominee_${i}_guardian`;
                      const guardianPanKey = `nominee_${i}_guardian_pan`;

                      // const guardianRelationKey = `nominee_${i}_guardian_relationship`;

                      // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
                      const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
                      const pincodeKey = `${prefix}_pin`;
                      const cityKey = `${prefix}_city`;
                      const stateKey = `${prefix}_state`;

                      const idTypeKey = `nominee_${i}_identity_type`;
                      const idNumberKey = `nominee_${i}_identity_number`;
                      const emailKey = `nominee_${i}_email`;
                      const mobileKey = `nominee_${i}_mobile`;
                      const countryKey = `nominee_${i}_country`;

                      // Special case for address keys
                      const address1Key =
                        i === 1
                          ? `nominee_${i}_address1`
                          : `nominee_${i}_address1`;
                      const address2Key =
                        i === 1
                          ? `nominee_${i}_address2`
                          : `nominee_${i}_address2`;

                      // const dob = new Date(values[dobKey]);
                      const age = calculateAge(values[dobKey]);
                      return (
                        <div key={i}>
                          <div className="mb-4">
                            <h5 className="nominee_title">
                              {`${getOrdinalSuffix(i)} Nominee:`}
                            </h5>
                          </div>
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={nameKey} className="form-label">
                                Nominee Name*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={nameKey}
                                name={nameKey}
                                placeholder="Enter Nominee Name"
                                value={values[nameKey]}
                                onChange={handleChange}
                              />
                              {errors[nameKey] && (
                                <div className="text-danger">
                                  {errors[nameKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={relationKey}
                                className="form-label"
                              >
                                Relation*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={relationKey}
                                id={relationKey}
                                value={values[relationKey]}
                                changeFunction={(value) =>
                                  setFieldValue(relationKey, value)
                                }
                                options={userNomineeDet?.data?.relations?.map(
                                  (relation) => ({
                                    value: relation.relationship_code,
                                    label: relation.relationship_name,
                                  })
                                )}
                              />
                              {errors[relationKey] && (
                                <div className="text-danger">
                                  {errors[relationKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`dob-${index}`}
                                className="form-label"
                              >
                                Nominee Date of Birth*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <DatePickerInput
                                id={dobKey}
                                selectedDate={values[dobKey]}
                                maxDate={new Date().toISOString().split("T")[0]}
                                onChange={(date) => setFieldValue(dobKey, date)}
                                name={dobKey}
                              />
                              {errors[dobKey] && (
                                <div className="text-danger">
                                  {errors[dobKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={`percent-${index}`}
                                className="form-label"
                              >
                                Nominee %*
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="number"
                                id={percentKey}
                                name={percentKey}
                                className="form-control"
                                placeholder="Enter Nominee %"
                                value={values[percentKey]}
                                onChange={handleChange}
                              />
                              {errors[percentKey] && (
                                <div className="text-danger">
                                  {errors[percentKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {(age >= 18 || age === null) && (
                            <>
                              {/* Nominee Type */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idTypeKey}
                                    className="form-label"
                                  >
                                    Nominee Identity Type *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={idTypeKey}
                                    id={idTypeKey}
                                    value={values[idTypeKey] || "1"}
                                    changeFunction={(value) =>
                                      setFieldValue(idTypeKey, value)
                                    }
                                    options={nomineeTypeOptions?.map(
                                      (state) => ({
                                        value: state.value,
                                        label: state.label,
                                      })
                                    )}
                                    disabled="true"
                                  />
                                  {errors[idTypeKey] && (
                                    <div className="text-danger">
                                      {errors[idTypeKey]}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Nominee Id Number */}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={idNumberKey}
                                    className="form-label"
                                  >
                                    Nominee ID number *
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={idNumberKey}
                                    name={idNumberKey}
                                    placeholder="Enter Id Number"
                                    value={values[idNumberKey] || ""}
                                    onChange={(e) => {
                                      const upperValue =
                                        e.target.value.toUpperCase();
                                      handleChange({
                                        target: {
                                          name: idNumberKey,
                                          value: upperValue,
                                        },
                                      });
                                    }}
                                  />
                                  {errors[idNumberKey] && (
                                    <div className="text-danger">
                                      {errors[idNumberKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Nominee Email */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={emailKey} className="form-label">
                                Nominee Email *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="email"
                                className="form-control"
                                id={emailKey}
                                name={emailKey}
                                placeholder="Enter Nominee Email"
                                value={values[emailKey] || ""}
                                // onChange={handleChange}
                                onChange={(e) =>
                                  setFieldValue(
                                    emailKey,
                                    e.target.value.toLowerCase()
                                  )
                                }
                              />
                              {errors[emailKey] && (
                                <div className="text-danger">
                                  {errors[emailKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Mobile Number */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={mobileKey} className="form-label">
                                Nominee Mobile *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="string"
                                className="form-control"
                                id={mobileKey}
                                name={mobileKey}
                                placeholder="Enter Nominee Mobile"
                                value={values[mobileKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[mobileKey] && (
                                <div className="text-danger">
                                  {errors[mobileKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address1Key}
                                className="form-label"
                              >
                                Nominee Address 1 *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address1Key}
                                name={address1Key}
                                placeholder="Enter Nominee Address 1"
                                value={values[address1Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address1Key] && (
                                <div className="text-danger">
                                  {errors[address1Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Address 2 */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={address2Key}
                                className="form-label"
                              >
                                Nominee Address 2
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={address2Key}
                                name={address2Key}
                                placeholder="Enter Nominee Address 2"
                                value={values[address2Key] || ""}
                                onChange={handleChange}
                              />
                              {errors[address2Key] && (
                                <div className="text-danger">
                                  {errors[address2Key]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee Pin Code */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={pincodeKey}
                                className="form-label"
                              >
                                Nominee Pincode *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                // type="number"
                                className="form-control"
                                id={pincodeKey}
                                name={pincodeKey}
                                placeholder="Enter Nominee Pincode"
                                value={values[pincodeKey] || ""}
                                onChange={(e) => {
                                  handleChange(e);
                                  callStateAndDistrict(
                                    e.target.value,
                                    cityKey,
                                    countryKey
                                  );
                                }}
                              />
                              {errors[pincodeKey] && (
                                <div className="text-danger">
                                  {errors[pincodeKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee City */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={cityKey} className="form-label">
                                Nominee City *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id={cityKey}
                                name={cityKey}
                                placeholder="Enter Nominee City"
                                value={values[cityKey] || ""}
                                onChange={handleChange}
                              />
                              {errors[cityKey] && (
                                <div className="text-danger">
                                  {errors[cityKey]}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Nominee State */}
                          {/* <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label htmlFor={stateKey} className="form-label">
                                Nominee State *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                name={stateKey}
                                id={stateKey}
                                value={values[stateKey] || ""}
                                changeFunction={(value) =>
                                  setFieldValue(stateKey, value)
                                }
                                options={userNomineeDet?.data?.states?.map(
                                  (state) => ({
                                    value: state.state_code,
                                    label: state.state_name,
                                  })
                                )}
                              />
                              {errors[stateKey] && (
                                <div className="text-danger">
                                  {errors[stateKey]}
                                </div>
                              )}
                            </div>
                          </div> */}

                          {/* Nominee Country */}
                          <div className="row align-items-center mb-4">
                            <div className="col-lg-5 col-md-6">
                              <label
                                htmlFor={countryKey}
                                className="form-label"
                              >
                                Nominee Country *
                              </label>
                            </div>
                            <div className="col-lg-7 col-md-6">
                              <SelectDropDown
                                id={countryKey}
                                name={countryKey}
                                value={formik.values[countryKey] || ""}
                                changeFunction={(value) =>
                                  formik.setFieldValue(countryKey, value)
                                }
                                options={userNomineeDet?.data?.countries?.map(
                                  (state) => ({
                                    value: state.country_name,
                                    label: state.country_name,
                                  })
                                )}
                              />

                              {errors[countryKey] && (
                                <div className="text-danger">
                                  {errors[countryKey]}
                                </div>
                              )}
                            </div>
                          </div>
                          {age >= 18 || age === null ? (
                            <></>
                          ) : (
                            // <div className="row align-items-center mb-4">
                            //   <div className="col-lg-5 col-md-6">
                            //     <label htmlFor={panKey} className="form-label">
                            //       Enter Pan Number*
                            //     </label>
                            //   </div>
                            //   <div className="col-lg-7 col-md-6">
                            //     <input
                            //       type="text"
                            //       className="form-control"
                            //       id={panKey}
                            //       name={panKey}
                            //       placeholder="Enter Pan Number"
                            //       value={values[panKey]}
                            //       onChange={handleChange}
                            //     />
                            //     {errors[panKey] && (
                            //       <div className="text-danger">
                            //         {errors[panKey]}
                            //       </div>
                            //     )}
                            //   </div>
                            // </div>
                            <>
                              {" "}
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Name*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianNameKey}
                                    name={guardianNameKey}
                                    className="form-control"
                                    placeholder="Guardian Name"
                                    value={values[guardianNameKey]}
                                    onChange={handleChange}
                                  />
                                  {errors[guardianNameKey] && (
                                    <div className="text-danger">
                                      {errors[guardianNameKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={`percent-${index}`}
                                    className="form-label"
                                  >
                                    Guardian Pan*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <input
                                    type="text"
                                    id={guardianPanKey}
                                    name={guardianPanKey}
                                    className="form-control"
                                    placeholder="Guardian Pan"
                                    value={values[guardianPanKey]}
                                    onChange={handleChange}
                                  />
                                  {errors[guardianPanKey] && (
                                    <div className="text-danger">
                                      {errors[guardianPanKey]}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="row align-items-center mb-4">
                                <div className="col-lg-5 col-md-6">
                                  <label
                                    htmlFor={guardianRelationKey}
                                    className="form-label"
                                  >
                                    Guardian Relation*
                                  </label>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                  <SelectDropDown
                                    name={guardianRelationKey}
                                    id={guardianRelationKey}
                                    value={values[guardianRelationKey]}
                                    changeFunction={(value) =>
                                      setFieldValue(guardianRelationKey, value)
                                    }
                                    options={userOnboardGetData?.data?.relations?.map(
                                      (relation) => ({
                                        value: relation.value,
                                        label: relation.label,
                                      })
                                    )}
                                  />
                                  {errors[guardianRelationKey] && (
                                    <div className="text-danger">
                                      {errors[guardianRelationKey]}
                                    </div>
                                  )}
                                </div>
                              </div> */}
                            </>
                          )}
                          <button
                            type="button"
                            className="delete_button text-decoration-none"
                            onClick={deleteNominee}
                          >
                            <span>-</span> Delete nominee
                          </button>
                        </div>
                      );
                    })}

                    {nomineeCount < 3 && (
                      <button
                        type="button"
                        className="more_button text-decoration-none"
                        onClick={addNominee}
                      >
                        <span>+</span> Add More
                      </button>
                    )}

                    <div className="d-flex justify-content-center gap-2 mt-lg-5 mt-4">
                      <button
                        type="submit"
                        className="form_button next_btn"
                        onClick={() => setIsFormSubmitted(true)}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageNominees;
